import MODULES from '../../formatmodules.selected.json';
async function loadModules() {
    return MODULES;
}
export { loadModules };
